import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController, AlertController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Globals } from "../../../../globals";
import { IncomeExpensesServices } from "../../services";
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsServices } from '../../../services/analyticsServices';


/**
 * Pantalla para crear un nuevo plato o update de uno existente
 * En el params recibimos si es un plato existente o uno nuevo. En caso de ser
 * UPDATE tenenmos que rellenar los campos del formulario
 */

@Component({
    selector: 'page-income-create-data.html',
    templateUrl: 'income-create-data.html',
})
export class IncomeCreateDataPage {
    public form: FormGroup;
    income_uid: any;
    update_state: boolean = false;
    base: any;
    tax: any;
    total: any;
    sales_sales = {};
    type_type: string;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public fb: FormBuilder,
        public globals: Globals,
        private toastCtrl: ToastController,
        public incomeExpensesServices: IncomeExpensesServices,
        private alertCtrl: AlertController,
        public translate: TranslateService,
        private analyServices: AnalyticsServices) {

        //Params
        this.update_state = this.navParams.get('update_state');
        this.income_uid = this.navParams.get('income_uid');

        //d
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: ''
        });
        loadingPopup.present();



        this.base = this.navParams.get('base');
        this.tax = this.navParams.get('tax');
        this.total = this.navParams.get('total');

        if (this.update_state) {
            this.form = fb.group({
                concept: [this.navParams.get('concept'), Validators.compose([Validators.required])],
                number: [this.navParams.get('number')],
                date: [this.incomeExpensesServices.timestampToDate(this.navParams.get('date'))],
                base: [this.navParams.get('base')],
                tax: [this.navParams.get('tax')],
                total: [this.navParams.get('total')],
                payment_method: [this.navParams.get('payment_method')],

            });
            this.globals.GAtrackView('Income/Expenses', 'Income/Expenses - Income - View', this.globals.restaurant.email, 'View', 'View income', 'Income/Expenses', '');
        } else {
            this.base = 0;
            this.tax = 0;
            this.total = 0;
            //
            this.form = fb.group({
                concept: ['', Validators.compose([Validators.required])],
                number: [0],
                date: [''],
                base: [0],
                tax: [0],
                total: [0],
                payment_method: ['giro'],

            });
        }
        loadingPopup.dismiss();


    }

    calculateRow() {
        this.form.value.base = this.base;
        this.form.value.tax = this.tax;

        this.total = this.form.value.base + ((this.form.value.base * this.form.value.tax) / 100);
        this.form.value.total = this.total;

    }

    submit() {
        if (this.form.valid) {
            // Si está en modo edición pero no tiene income_uid, mostrar error
            if (this.update_state && !this.income_uid) {
                let toast = this.toastCtrl.create({
                    message: this.translate.instant('instant-error-cannot-edit-billing-income'),
                    duration: 4000,
                    position: 'top'
                });
                toast.present();
                return;
            }

            if (!this.update_state) {
                this.insert();
            } else {
                this.update();
            }
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-rellena-campos-continuar'),
                duration: 3000,
                position: 'top'
            });
            toast.present();
        }
    }

    insert() {
        this.incomeExpensesServices.afs.collection('income').add({
            'UID_RESTAURANT': this.globals.restaurant_uid,
            'number': this.form.value.number,
            'date': new Date(this.form.value.date),
            'concept': this.form.value.concept,
            'base': this.form.value.base,
            'tax': this.form.value.tax,
            'total': this.form.value.total,
            'payment_method': this.form.value.payment_method,

        }).then(doc => {
            this.globals.GAtrackView('Income/Expenses', 'Income/Expenses - Income - Create', this.globals.restaurant.email, 'Create/Update', 'Create income', 'Income/Expenses', this.form.value.number);
            if (this.form.value.payment_method === 'efectivo') {
                this.type_type = 'cash';
            }
            else if (this.form.value.payment_method === 'tarjeta') {
                this.type_type = 'card';
            }
            else {
                this.type_type = 'not_specified';
            }

            this.sales_sales = {
                'uid': this.globals.restaurant_uid,
                'uid_doc': doc.id,
                'date': new Date(this.form.value.date),
                'sales': this.form.value.total,
                'type': "sales_sales",
                'type_type': this.type_type,
                'persons': 0,
                'zone': '',
                'discount_type': null,
                'discount': 0,
                'foodcost': 0,
                'app_section': 'income',
                'text': this.form.value.concept,
                'waiter': null,
                'tip': 0,
            };
            this.analyServices.sendSalesSales(this.sales_sales);

            this.navCtrl.pop();

        });
    }

    update() {

        this.incomeExpensesServices.afs.collection('income').doc(this.income_uid).update({
            'number': this.form.value.number,
            'date': new Date(this.form.value.date),
            'concept': this.form.value.concept,
            'base': this.form.value.base,
            'tax': this.form.value.tax,
            'total': this.form.value.total,
            'payment_method': this.form.value.payment_method,
        }).then(doc => {
            this.globals.GAtrackView('Income/Expenses', 'Income/Expenses - Income - Update', this.globals.restaurant.email, 'Create/Update', 'Update income', 'Income/Expenses', this.form.value.number);
            this.navCtrl.pop();
        });
    }

    delete() {
        // Si está en modo edición pero no tiene income_uid, mostrar error
        if (this.update_state && !this.income_uid) {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-error-cannot-delete-billing-income'),
                duration: 4000,
                position: 'top'
            });
            toast.present();
            return;
        }

        let alert = this.alertCtrl.create({

            title: this.translate.instant('general-eliminar-ingreso'),
            message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.globals.GAtrackView('Income/Expenses', 'Income/Expenses - Income - Delete', this.globals.restaurant.email, 'Delete', 'Delete income', 'Income/Expenses', this.form.value.number);
                        this.incomeExpensesServices.delete(this.income_uid, 'income');
                        this.redirect();
                    }
                }
            ]
        });
        alert.present();
    }
    async redirect() {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: ''
        });
        loadingPopup.present();
        await this.globals.delay(1000);
        this.navCtrl.pop();
        loadingPopup.dismiss();
    }

}


// WEBPACK FOOTER //
// ./src/pages/income-expenses/income-create/income-create-data/income-create-data.ts